import reachingReflection from '../../../../assets/svgs/actors/lizReflection/reachingReflection'

import { REACHING_REFLECTION } from '../../../../constants/scene/actors/liz'

export default {
    [REACHING_REFLECTION]: reachingReflection,
}
